<template>
    <div id="planos-pro" class="card col-12 col-md-12 p-4">
        <div class="row align-items-center">
            <template>
                <div class="d-none d-md-flex col-12 col-md-6 p-3 position-relative justify-content-center" style="max-height: 611px; height: 100%">
                    <div class="card-animation">
                        <img
                            class="card-frente position-relative" 
                            :src="`https://storage.torcedordevantagens.com.br/${idClube}/cart_frente.png`"
                            style="width: 86%; left: 12%">
                    </div>
                </div>
                <div class="d-flex d-md-none  col-12 col-md-6 p-3 position-relative justify-content-center">
                    <div class="card-animation">
                        <img
                            class="card-frente"
                            :src="`https://storage.torcedordevantagens.com.br/${idClube}/cart_frente.png`"
                            data-aos="fade-left"
                            data-aos-duration="500"
                            :data-aos-offset="mobile ? '0' : '100'"
                            data-aos-anchor-placement="bottom-bottom"
                            style="width: 95%; left: 50%; transform: translateX(-50%);"
                        >
                    </div>
                </div>
            </template>
            <div class="col-12 col-md-6 px-3 px-md-5 py-3 d-flex flex-column justify-content-center">
                <div class="row mb-3">
                    <div class="col">
                        <h1 v-if="selectedPlan != null" class="title text-start text-uppercase mb-4" id="planos-pro-title" style="font-family: sans-serif"><strong>{{ selectedPlan.nome_display }}</strong></h1>
                        <div v-if="selectedPlan != null" v-html="vantagens" class="text-start"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div v-if="planos.length > 1" class="text-start mb-3">Escolha a modalidade de seu plano:</div>
                        <div id="form-planos">
                            <template v-if="planos.length > 1">
                                <div v-for="(plan, key) in plans" :key="key" class="plano-opcao position-relative mb-3" :class="isActive(plan.id) ? 'active' : ''" style="border-radius: 8px; border: 2px solid white">
                                    <div v-if="plan.hint && isActive(plan.id)" class="economy-hint position-absolute rounded px-2" style="right: 15px; top: -12px; background-color: rgb(0, 173, 238); color: black">
                                        <small>{{plan.hint}}</small>
                                    </div>
                                    <label for="plano1" class="d-flex align-items-center mb-0 px-1 py-3" v-on:click="switchPlan(plan.id)">
                                        <div class="checkmark mx-3"></div>
                                        <div class="d-flex flex-column align-items-start">
                                            <h4 class="text-start mb-0" style="color: white"><span class="text-uppercase">{{ !(plan.txt_valor_promo) ? plan.nome_display : plan.txt_valor_promo.split('PLANO ')[1].toLowerCase()}}: </span><span class="price">{{formatMoney(plan.valor)}}<small>/mês</small></span></h4>
                                            <template v-if=" !(plan.txt_valor_promo) ? true : plan.txt_valor_promo.split('PLANO ')[1] == 'ANUAL'">
                                                <small class="installments-subtitle d-none text-start">Anuidade de {{formatMoney(plan.valor * 12)}} parcelada em até 6x de R$ 29,80</small>
                                            </template>
                                            <template v-else-if=" !(plan.txt_valor_promo) ? true : plan.txt_valor_promo.split('PLANO ')[1] == 'SEMESTRAL'">
                                                <small class="installments-subtitle d-none text-start">Semestralidade  de {{formatMoney(plan.valor * 6)}} parcelada em até 3x de R$ 35,80</small>
                                            </template>
                                            <template v-else-if=" !(plan.txt_valor_promo) ? true : plan.txt_valor_promo.split('PLANO ')[1] == 'TRIMESTRAL'">
                                                <small class="installments-subtitle d-none text-start">Trimestralidade  de {{formatMoney(plan.valor * 3)}} com pagamento à vista</small>
                                            </template>
                                        </div>
                                    </label>
                                </div>
                            </template>
                            <template v-else>
                                <div class="mb-4">
                                    <small style="display: block; width: 100%; text-align: start">Contribuição mensal a partir de:</small>
                                    <h4 class="text-start mb-0" style="color: white"><span class="price"><span style="font-size: 27px; font-weight: bolder;">{{formatMoney(plans[0].valor)}}</span><small>/mês</small></span></h4>
                                </div>
                            </template>
                            <a v-if="selectedPlan && redirectTo != ''" :href="redirectURL" class="submit-btn btn btn-lg btn-block btn-primary fw-bold text-uppercase" style="border-radius: 8px">Quero Fazer Parte</a>
                            <a v-if="selectedPlan && redirectTo == '' && selectedPlan.id != current" @click="submit" class="submit-btn btn btn-lg btn-block btn-primary fw-bold text-uppercase" style="border-radius: 8px;">Avançar</a>
                            <a v-if="selectedPlan && redirectTo == '' && selectedPlan.id == current" class="submit-btn btn btn-lg btn-block btn-disabled fw-bold text-uppercase" style="border-radius: 8px;">Modalidade Atual</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    export default Vue.extend({
        data() {
            return {
                selectedPlan: null,
                plans: []
            }
        },
        props: {
            idClube: {
                type: Number,
                default: 0
            },
            planos: {
                type: Array,
                default: []
            },
            redirectTo: {
                type: String,
                default: ''
            },
            current: {
                type: Number,
                default: 0
            },
        },
        mounted() {
            this.plans = this.treatPlans(this.planos)
            this.selectedPlan = this.plans[0]
        },
        methods: {
            // Hardcoded parsing...
            // Isso aqui possivelmente vai precisar ser alterado caso a
            // estrutura dessas informações (showcase_thema) mude.
            treatPlans(plans) {
                const treated = plans.map(plan => {
                    const copy = { ...plan }
                    const temp = document.createElement('div')
                    temp.innerHTML = copy.showcase_thema
                    temp.innerHTML = temp.firstChild.innerHTML  // p tag
                    
                    // adiciona atributo hint
                    const hint = [...temp.querySelectorAll('strong')].filter(el => el.innerText.toLowerCase().startsWith('economize'))[0]
                    if (hint) {
                        copy.hint = hint.innerText
                        temp.removeChild(hint)
                    }
                    
                    // trata o showcase_thema
                    temp.innerHTML = temp.innerHTML.split('<br>').filter(str => str.startsWith('• ')).join('<br>')
                    copy.showcase_thema = temp.innerHTML
                    
                    return copy
                })
                return treated
            },
            switchPlan(id) {
                this.selectedPlan = this.plans.filter(plan => plan.id == id)[0]
            },
            isActive(id) {
                return this.selectedPlan.id == id
            },
            formatMoney(value) {
                const formatter = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'})
                return formatter.format(value)
            },
            submit() {
                this.$emit('submit', { ... this.selectedPlan })
            }
        },
        computed: {
            vantagens: function () {
                return this.selectedPlan.vantagens
            },
            redirectURL: function () {
                return this.redirectTo + this.selectedPlan.id
            },
            mobile() {
                return window.innerWidth < window.innerHeight
            }
        }
    })
</script>

<style lang="scss" scoped>
    .card-animation {

        width: 100%;

        @media (max-aspect-ratio: 1/1) {
            min-height: 350px;
        }

        .card-frente {
            width: 80%;
            object-fit: contain;
            position: absolute;
            top: 0;
            left: 25%;
            z-index: 999;

            @media (max-aspect-ratio: 1/1) {
                width: 75%;
                left: 15%;
            }
        }

        .card-verso {
            width: 80%;
            object-fit: contain;
            position: absolute;
            top: 50%;
            left: 10%;
            z-index: 998;

            @media (max-aspect-ratio: 1/1) {
                width: 75%;
                left: 10%;
            }
        }
    }
</style>